module.exports = __webpack_public_path__ + "img/2.1a27bfae.1a27bfae.gif";